<!-- 门店信息 --> 
<template>
    <div class="page_content">
        <!-- <subComponents ref="showSelectData"></subComponents> -->
        <!-- <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增门店信息' : '编辑门店信息'" width="100%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"
                   :close-on-press-escape="true" center>
            <storeModal v-if="showStatus" ref="storeMastRef" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></storeModal>
        </el-dialog> -->
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <storeModal v-if="showStatus" ref="storeModal" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></storeModal>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div style="display: flex; just-content: space-between">
            <div class="page_content_center" style="width: 75%">
                <el-table v-if="pageShowData.jurTableVo" :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="storePeopleClick" :data="returnData.list" :height="tableHeight" border
                          style="width: 100%" highlight-current-row size="mini">
                    <!-- 主信息 -->

                    <el-table-column header-align='center' label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini" @change="handleRadioChange(scope.row, scope.$index)">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField"
                                     show-overflow-tooltip :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'periodValidity'">
                                <span v-if="scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'memDayType'">{{ Number(scope.row.memDayType) === 1 ? "周" : "日" }}</span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                            </span>
                            <el-tag v-else-if="tableValye.entityField == 'storeState'" size="mini" :type="scope.row.storeState == 0 ? 'danger' : 'success'">{{ scope.row.storeState == 0 ? "停用" : "启用" }}</el-tag>
                            <el-tag v-else-if="tableValye.entityField == 'autoPrint'" size="mini" :type="scope.row.autoPrint == 0 ? 'danger' : 'success'">{{ scope.row.autoPrint == 0 ? "否" : "是" }}</el-tag>
                            <el-tag v-else-if="tableValye.entityField == 'scanCode'" size="mini" :type="scope.row.scanCode == 0 ? 'danger' : 'success'">{{ scope.row.scanCode == 0 ? "否" : "是" }}</el-tag>
                            <el-tag v-else-if="tableValye.entityField == 'autoPayMoney'" size="mini" :type="scope.row.autoPayMoney == 0 ? 'danger' : 'success'">{{ scope.row.autoPayMoney == 0 ? "否" : "是" }}</el-tag>
                            <el-tag v-else-if="tableValye.entityField == 'isChangePriceCheck'" size="mini"
                                    :type="scope.row.isChangePriceCheck == 0 ? 'danger' :scope.row.isChangePriceCheck == 1 ? 'success':scope.row.isChangePriceCheck == 2 ? 'primary ' : ''">{{ scope.row.isChangePriceCheck == 0 ? "不验证":scope.row.isChangePriceCheck == 1 ? "全部验证":scope.row.isChangePriceCheck == 2 ? "仅调低价格验证" : "" }}</el-tag>
                            <el-input clearable style="width: 90px; margin: 0 1px" @blur="blur(scope.$index, tableValye.entityField)" v-else-if="tableValye.fieldType == 'input'" type="number"
                                      v-model="scope.row[tableValye.entityField]"></el-input>
                            <span v-else>{{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </div>
            <div style="width: 25%">
                <div class="btns">
                    <el-button type="primary" size="mini" @click="openPer">新增
                    </el-button>

                </div>
                <el-table class="mainTable xunjia" ref="mxTable" :data="storePeopleList" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                    <el-table-column align="center" label="门店人员列表">
                        <el-table-column v-for="(tableValye, tableKey) in pageShowPeopleData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                         :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                            <template slot-scope="scope">
                                <span>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="操作" align="center" min-width="80px">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="delDetail(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
        </el-dialog>

        <!-- 人员列表 -->
        <el-dialog title="人员列表" v-if="perDia" :visible.sync="perDia">
            <div style="margin-bottom: 15px;">
                <el-input v-model="searchPersonName" placeholder="请输入人员姓名进行筛选" clearable style="width: 300px;" @input="handlePersonSearch" @clear="handlePersonSearch" @keyup.enter.native="handlePersonSearch">

                </el-input>
                <el-button style="border-radius: 0;" type="primary" @click="handlePersonSearch">搜索</el-button>
            </div>
            <el-table :data="perList" ref="perList" border @selection-change="handleSelectionChange" height="450px" size="mini" v-loading="loading">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column property="opmName" label="人员姓名" show-overflow-tooltip></el-table-column>
                <el-table-column property="opmIdnumber" label="人员身份证" show-overflow-tooltip></el-table-column>
                <el-table-column property="opmMobilenumber" label="人员手机号" show-overflow-tooltip></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="perDia = false">取 消</el-button>
                <el-button type="primary" @click="selPerson">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改线上零售配置" v-if="configurationShow" :visible.sync="configurationShow" width="600px">
            <el-form inline :model="sendDataList" ref="sendDataInfo" label-width="80px" class="demo-ruleForm">
                <el-form-item label="收款台" prop="deskId">
                    <el-select class="input" v-model="sendDataList.deskId" placeholder="请选择">
                        <el-option v-for="(val, key) in formList.deskList" :key="key" :label="val.name" :value="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账簿名称" prop="bookId">
                    <el-select class="input" v-model="sendDataList.bookId" placeholder="请选择">
                        <el-option v-for="(val, key) in formList.bookList[sendDataList.deskId]" :key="key" :label="val.name" :value="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收银员" prop="cashierId">
                    <el-select class="input" v-model="sendDataList.cashierId" placeholder="请选择">
                        <el-option v-for="(val, key) in formList.cashierList" :key="key" :label="val.name" :value="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售员" prop="salesPersonId">
                    <el-select class="input" v-model="sendDataList.salesPersonId" placeholder="请选择">
                        <el-option v-for="(val, key) in formList.salesPersonList" :key="key" :label="val.name" :value="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门店配送操作员" prop="deliInOpm">
                    <el-select class="input" v-model="sendDataList.deliInOpm" placeholder="请选择" filterable>
                        <el-option v-for="(val, key) in dnperList" :key="key" :label="val.opmName" :value="val.opmId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="总部配送操作员" prop="deliOutOpm">
                    <el-select class="input" v-model="sendDataList.deliOutOpm" placeholder="请选择" filterable>
                        <el-option v-for="(val, key) in perList" :key="key" :label="val.opmName" :value="val.opmId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="configurationShow = false">取 消</el-button>
                <el-button type="primary" @click="openClick">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="关联线上店铺" v-if="shopShow" :visible.sync="shopShow" width="600px">
            <el-form inline class="demo-ruleForm">
                <el-form-item>
                    <el-button type="primary" size="mini" @click="shopClick">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="shopList" ref="perList" border height="300" size="mini">
                <el-table-column prop="shopId" label="电商店铺ID">
                    <template slot-scope="scope">
                        <el-input placeholder="" v-model="scope.row.shopId" clearable>
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="shopName" label="电商店铺名称">
                    <template slot-scope="scope">
                        <el-input placeholder="" v-model="scope.row.shopName" clearable>
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="delClick(scope.$index)" type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="shopShow = false">取 消</el-button>
                <el-button type="primary" @click="shopOpenClick">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="药师列表" v-if="pharmacistShow" :visible.sync="pharmacistShow" width="600px">
            <el-table :data="pharmacistList" border height="300" size="mini">
                <el-table-column prop="doctorName" label="药师名称" min-width="150"></el-table-column>
                <el-table-column prop="addRate" label="加价率" min-width="150">
                    <template slot-scope="scope">
                        <el-input @mousewheel.native.prevent placeholder="" type="number" v-model="scope.row.addRate" clearable @blur="validateAddRate(scope.row)">
                        </el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pharmacistShow = false">取 消</el-button>
                <el-button type="primary" @click="plusClick">保 存</el-button>
            </div>
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>

        <printPlanStore ref="printPlanStore" @confirm="confirmGetData"></printPlanStore>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
// 门店新增/编辑组件
import storeModal from "./storeModal.vue"
import { nameList, peopleList, searchList } from "./storeMastList.js"

import printPlanStore from "@/components/printPlanStore.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        storeModal,
        printPlanStore
    },
    data() {
        //这里存放数据
        return {
            sField: "",
            exTitle: "",
            exWidth: "",
            searchList: searchList,
            getRequestData: {
                businessId: "",
                creater: 0,
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
                end: "",
                storeName: "",
                storeType: "",
                coName: "",
                groupName: "",
            },
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            multipleSelection: [],
            pageShowData: {},
            pageShowPeopleData: {},
            formDataList: [],
            tableFlag: 0,
            storeIds: "",
            storePeopleList: [],
            tableHeight: 0,
            showStatus: false,
            actionData: {},
            perDia: false,
            perList: [],
            loading: false,
            searchPersonName: "",
            selectedRowIndex: null,
            //-
            configurationShow: false,
            formList: {},
            sendDataList: {
                bookId: "",//账簿
                cashierId: '',//收银员
                deskId: "",//款台
                salesPersonId: '',//销售员
                storeId: "",//门店
                storeName: "",//门店名称
                deliInOpm: "",
                deliOutOpm: "",
            },
            dnperList: [],
            //---
            shopShow: false,
            shopList: [],
            //--------------
            pharmacistShow: false,
            pharmacistList: [],
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.pspmBuycus = ""
                }
            },
            deep: true,
        },
        pharmacistList: {
            handler: function (newValue, oldValue) {
                newValue.forEach(item => {
                    item.addRate = this.$common.updataNum('addRate', item).addRate
                })
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        delClick(index) {
            this.shopList.splice(index, 1)
        },
        shopClick() {
            var arr = this.shopList.filter(item => item.shopId == "" || item.shopName == "")
            if (arr.length != 0) {
                return this.$message.error('请填写店铺名称或店铺id')
            }
            this.shopList.push({
                shopId: "",
                shopName: ""
            })
        },
        confirmGetData() {
            this.getDataList()
            sessionStorage.setItem('storeIdLs', this.storeIds)
            sessionStorage.setItem('storePrintContent', this.returnData.list[this.selectedRowIndex].skPrint ? this.returnData.list[this.selectedRowIndex].skPrint : '')
            sessionStorage.setItem('storePrintContentHj', this.returnData.list[this.selectedRowIndex].hjPrint ? this.returnData.list[this.selectedRowIndex].hjPrint : '')
            sessionStorage.setItem('storePrintContentJb', this.returnData.list[this.selectedRowIndex].jbPrint ? this.returnData.list[this.selectedRowIndex].jbPrint : '')
        },
        // 子组件触发
        drawerCancel(e) {
            console.log(e, "+++++++++")
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            //  if (orderId) {
            //     // 设置为true 打开穿透组件首页
            //     var isPenetrate = true
            //     // 设置缓存 存入点击单号
            //     this.resetSetItem('penetrateOrderId', orderId);
            //     // 与父级跨域通信 传递isPenetrate参数
            //     window.parent.postMessage({  //向窗口发送MessageEvent消息
            //        cmd: 'returnFormJson',
            //        params: { isPenetrate } //参数
            //     }, '*');
            //  }
            this.getPageInfo()
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            )
        },
        storePeopleClick(row) {
            this.storeIds = row.storeId
            sessionStorage.setItem('storeIdLs', this.storeIds)
            sessionStorage.setItem('storePrintContent', this.returnData.list[this.selectedRowIndex].skPrint ? this.returnData.list[this.selectedRowIndex].skPrint : '')
            sessionStorage.setItem('storePrintContentHj', this.returnData.list[this.selectedRowIndex].hjPrint ? this.returnData.list[this.selectedRowIndex].hjPrint : '')
            this.selectedRowIndex = this.returnData.list.findIndex(item => item.storeId === row.storeId)
            this.getDataPeopleList()
        },

        // 检索Id, 索引(表格中), 标识
        openSearch(val) {
            this.setType = val.type
            this.seId = val.sId
            this.setField = val.sField
            this.parentSearchData[this.setType] = this.getRequestData[this.setType]
            if (this.setType == 'salesName') {
                this.parentSearchData.opmSalesperson = 1
            }
            this.DialogVisible = true

        },

        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val) {
                if (this.setType == 'salesName') {
                    this.getRequestData.salesName = val.opmName
                    this.getRequestData.salesId = val.opmId
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
        },
        //   新增人员
        openPer() {
            this.perDia = true;
            this.searchPersonName = ""; // 重置搜索条件
            this.queryOperator();
        },
        //查询人员列表
        async queryOperator() {
            this.loading = true;
            let params = {
                businessId: "",
                creater: 0,
                end: 0,
                opmName: this.searchPersonName || "",
                ormId: 0,
                page: 1,
                rows: 9999,
                start: 0,
                storeId: this.storeIds
            };
            let responseData = await this.$http.queryStoreNoBindUser(params);
            this.loading = false;
            if (responseData && responseData.status == 200) {
                // 获取当前已存在的人员ID列表
                const existIds = this.storePeopleList.map(item => item.opmId);
                // 过滤掉已存在的人员
                this.perList = (responseData.result.list || []).filter(item => !existIds.includes(item.opmId));
            } else {
                this.perList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async selPerson() {
            // 只添加未存在于storePeopleList中的人员
            const existIds = this.storePeopleList.map(item => item.opmId);
            const addList = this.multipleSelection.filter(item => !existIds.includes(item.opmId));

            // 准备保存的数据
            let pushData = {
                opmIds: addList.map(item => item.opmId),
                storeId: this.storeIds,
            };

            // 直接调用保存接口
            let responseData = await this.$http.addstoreOper(pushData);
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                // 重新获取人员列表
                this.getDataPeopleList();
                // 关闭对话框
                this.perDia = false;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async delDetail(index) {
            this.$confirm("确定删除该记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    try {
                        // 调用删除接口
                        let responseData = await this.$http.delstoreOper({
                            ids: [this.storePeopleList[index].id],
                        });

                        if (responseData.status == 200) {
                            // 保存被删除的人员信息
                            const deletedPerson = this.storePeopleList[index];
                            // 从列表中删除
                            this.storePeopleList.splice(index, 1);
                            // 如果当前正在显示人员选择对话框，则更新可选列表
                            if (this.perDia) {
                                this.perList.push(deletedPerson);
                            }
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getDataPeopleList()
                        } else {
                            this.$message({
                                message: responseData.message,
                                type: "error",
                            });
                        }
                    } catch (error) {
                        this.$message({
                            message: "删除失败，请重试",
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 勾选明细
        handleSelectionChange(val) {
            console.log(val, "+++++++++")
            this.multipleSelection = val
        },



        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },



        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            console.log(responseData);
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                this.headerData = this.pageShowData.jurHead.jurconfigform;
                this.pageShowPeopleData = JSON.parse(JSON.stringify(peopleList))
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.queryData();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async queryData() {
            let res = await this.$http.queryStoremasts(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result.list
                this.returnData.total = res.result.total
                this.returnData.pageNum = res.result.pageNum
                this.returnData.pages = res.result.pages
                if (this.returnData.list.length > 0) {
                    this.storeIds = this.returnData.list[0].storeId
                    sessionStorage.setItem('storeIdLs', this.storeIds)
                    sessionStorage.setItem('storePrintContent', this.returnData.list[0].skPrint ? this.returnData.list[0].skPrint : '')
                    sessionStorage.setItem('storePrintContentHj', this.returnData.list[0].hjPrint ? this.returnData.list[0].hjPrint : '')
                    this.getDataPeopleList()
                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                } else {
                    this.storePeopleList = []
                }
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        async shopQuery() {
            
            const res = await this.$http.retailWebgetWebShopInfo({ ids: [this.returnData.list[this.selectedRowIndex].storeId] })
            if (res.status == 200) {
                this.shopList = res.result
                this.shopShow = true
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: this.returnData.list[this.selectedRowIndex],
                    }
                    break
                case 2:
                    this.delDataAction()
                    break
                case 4:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({ type: "error", message: "请先选中要操作的数据" })
                        return
                    }
                    break
                case 10:
                    this.showPrintPlan()
                    break
                case 11:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.shopQuery()
                    break
                case 12:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.retailWebgetSingleStoreConfig()
                    break
                case 13:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.queryPharmacist()
                    break



            }
        },
        async plusClick() {
            var arr = this.pharmacistList.filter(item => item.addRate < 0 && item.addRate > 1)
            if (arr.length > 0) {
                return this.$message.error('请输入正确的加价率')
            }
            const params = {
                storeId: this.returnData.list[this.selectedRowIndex].storeId,
                detailList: this.pharmacistList.map(item => {
                    return {
                        doctorId: item.doctorId,
                        addRate: item.addRate,
                    }
                })
            }
            const res = await this.$http.storemastsetDoctorAddRate(params)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.pharmacistShow = false
            } else {
                this.$message.error(res.message)
            }
        },
        async queryPharmacist() {
            const params = {
                storeId: this.returnData.list[this.selectedRowIndex].storeId,
            }
            const res = await this.$http.storemastgetDoctorAddRate(params)
            console.log(res);
            if (res.status == 200) {
                this.pharmacistList = res.result
                this.pharmacistShow = true
            }

        },
        validateAddRate(row) {
            // 验证加价率是否在0到1之间
            const value = parseFloat(row.addRate);
            if (isNaN(value) || value < 0 || value > 1) {
                this.$message.error('加价率必须在0到1之间');
                // 恢复为原来的值或设为0
                row.addRate = 0;
                return false;
            }
            // 保留两位小数
            row.addRate = parseFloat(value.toFixed(3));
            return true;
        },
        async shopOpenClick() {
            var arr = this.shopList.filter(item => item.shopId == "" || item.shopName == "")
            if (arr.length != 0) {
                return this.$message.error('请填写店铺名称或店铺id')
            }
            const res = await this.$http.retailWebsetWebShopInfo({
                shopList: this.shopList.map(item => {
                    return {
                        shopId: item.shopId,
                        shopName: item.shopName,
                        storeId: this.returnData.list[this.selectedRowIndex].storeId,
                    }
                }),
                storeId: this.returnData.list[this.selectedRowIndex].storeId,
            })
            if (res.status == 200) {
                this.$message({
                    message: "保存成功",
                    type: "success",
                })
                this.shopShow = false
                this.getDataList()
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        async retailWebgetSingleStoreConfig() {
            const res = await this.$http.retailWebgetSingleStoreConfig({ ids: [this.returnData.list[this.selectedRowIndex].storeId] })
            console.log(res);
            if (res.status == 200) {
                this.formList = res.result
                let deskId = "";
                let bookId = "";
                if (this.formList.deskList.length > 0) {
                    deskId = this.formList.deskList[0].id
                }
                if (this.formList.bookList[deskId] != undefined) {
                    bookId = this.formList.bookList[deskId][0].id
                }
                var obj = {
                    bookId: bookId,//账簿
                    cashierId: this.formList.cashierList.length > 0 ? this.formList.cashierList[0].id : '',//收银员
                    deskId: deskId,//款台
                    salesPersonId: this.formList.salesPersonList.length > 0 ? this.formList.salesPersonList[0].id : '',//销售员
                    storeId: this.formList.storeId,//门店
                    storeName: this.formList.storeName,//门店名称
                    deliInOpm: this.formList.deliInOpm || "",
                    deliOutOpm: this.formList.deliOutOpm || "",
                }
                this.queryOperators1()//店内
                this.sendDataList = obj
                this.configurationShow = true
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }

        },
        //查询人员列表
        async queryOperators() {
            let params = {
                businessId: "",
                creater: 0,
                end: 0,
                opmName: "",
                ormId: 0,
                page: 1,
                rows: 9999,
                start: 0,
                storeId: this.returnData.list[this.selectedRowIndex].storeId
            };
            //queryStoreBindUser
            let responseData = await this.$http.queryStoreNoBindUser(params);
            if (responseData && responseData.status == 200) {
                // 获取当前已存在的人员ID列表
                const existIds = this.dnperList.map(item => item.opmId);
                // 过滤掉已存在的人员
                this.perList = (responseData.result.list || []).filter(item => !existIds.includes(item.opmId));
                // 过滤掉已存在的人员
                this.perList = responseData.result.list
            } else {
                this.perList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async queryOperators1() {
            let responseData = await this.$http.queryStoreBindUser({
                businessId: "",
                creater: 0,
                end: 0,
                opmName: "",
                ormId: 0,
                page: 0,
                rows: 0,
                start: 0,
                storeId: this.returnData.list[this.selectedRowIndex].storeId,
            })
            if (responseData.status == 200) {
                // 确保返回的数据是数组
                this.dnperList = responseData.result.list
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
            this.queryOperators()//总部

        },
        async openClick() {
            this.sendDataList.storeId = this.returnData.list[this.selectedRowIndex].storeId
            const params = {
                storeConfigList: [this.sendDataList]
            }
            let res = await this.$http.retailWebsetStoreDefaultConfig(params)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.configurationShow = false
                this.getDataList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表 门店
        async getDataList() {
            let responseData = await this.$http.queryStoremasts(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.returnData.pages = responseData.result.pages
                if (this.returnData.list.length > 0) {
                    this.storeIds = this.returnData.list[0].storeId
                    sessionStorage.setItem('storeIdLs', this.storeIds)
                    sessionStorage.setItem('storePrintContent', this.returnData.list[0].skPrint ? this.returnData.list[0].skPrint : '')
                    sessionStorage.setItem('storePrintContentHj', this.returnData.list[0].hjPrint ? this.returnData.list[0].hjPrint : '')
                    this.getDataPeopleList()
                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                } else {
                    this.storePeopleList = []
                }
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        // 查询当前门店绑定的人员
        async getDataPeopleList() {
            this.storePeopleList = []
            let responseData = await this.$http.queryStoreBindUser({
                businessId: "",
                creater: 0,
                end: 0,
                opmName: "",
                ormId: 0,
                page: 0,
                rows: 0,
                start: 0,
                storeId: this.storeIds,
            })
            if (responseData.status == 200) {
                console.log(responseData.result, 'responseData.result');
                // 确保返回的数据是数组
                this.storePeopleList = Array.isArray(responseData.result.list)
                    ? responseData.result.list
                    : []
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlanStore.openDia('', 'printData/retailOrderPrint', sessionStorage.getItem('printJurId'), '', 'all', '', '', '')
            } else {
                return
            }
        },
        // 删除数据
        delDataAction() {
            if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.returnData.list[this.selectedRowIndex].storeId],
                    }
                    let responseData = await this.$http.delstore(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })

                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },

        // 人员搜索处理
        handlePersonSearch() {
            this.queryOperator();
        },
        handleRadioChange(row, index) {
            console.log(row, 'row333333333');

            this.selectedRowIndex = index;
            this.storeIds = row.storeId;


            sessionStorage.setItem('storeIdLs', this.storeIds)
            sessionStorage.setItem('storePrintContent', this.returnData.list[this.selectedRowIndex].skPrint ? this.returnData.list[this.selectedRowIndex].skPrint : '')
            sessionStorage.setItem('storePrintContentHj', this.returnData.list[this.selectedRowIndex].hjPrint ? this.returnData.list[this.selectedRowIndex].hjPrint : '')
            this.getDataPeopleList();
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    updated() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    }, //生命周期 - 更新之后

}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

::v-deep.xunjia .el-button {
    font-size: 12px;
    padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
    color: #fff;
    background-color: #f78989;
    border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
    height: 100% !important;
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
    background-color: #fff;
}
.input {
    width: 200px;
}
</style>
